import IconButton from 'apollo-react/components/IconButton';
import MenuItem from 'apollo-react/components/MenuItem';
import Select from 'apollo-react/components/Select';
import Trash from 'apollo-react-icons/Trash';
import React from 'react';

import { getUITA } from '../../../../../../utils/commonUtils';

const fieldStyles = {
  style: {
    marginTop: 3,
    marginLeft: -8,
  },
};

export const ActionCell = ({ row: { id, deleteRow } }) => (
  <div style={{ paddingTop: 10 }}>
    <IconButton
      onClick={() => deleteRow(id)}
      ui-ta={getUITA('Update Actions Mapping Table', 'Delete Btn')}
    >
      <Trash />
    </IconButton>
  </div>
);

export const EntityFieldsList = ({ row }) => {
  const { entityFields, id, From, DummyFrom, To, ToDataType, editRow } = row;

  const getTranslateToList = (value) => {
    const { label } = entityFields.find((field) => field.value === value);
    return label.split('(')[0].trim();
  };

  const onChangeHandler = ({ target }) => {
    const newValue = {
      id,
      DummyFrom,
      From,
      DummyTo: getTranslateToList(target.value),
      To: target.value,
      ToDataType,
    };

    editRow(id, newValue);
  };

  return (
    <div style={{ width: 'auto' }}>
      <Select
        size="small"
        fullWidth
        value={To}
        onChange={onChangeHandler}
        canDeselect={false}
        ui-ta={getUITA('Update Actions Mapping Table', 'To Values')}
        {...fieldStyles}
      >
        {entityFields.map(({ label, value }) => {
          return (
            <MenuItem key={`${row.id} + ${value}`} value={value}>
              {label}
            </MenuItem>
          );
        })}
      </Select>
    </div>
  );
};

export const DataSourceValuesList = ({ row }) => {
  const { dataSourceFields, id, From, DummyTo, To, ToDataType, editRow } = row;

  const getTranslateFromList = (value) => {
    const { Label } = dataSourceFields.find(({ Name }) => Name === value);
    return Label;
  };

  const onChangeHandler = ({ target }) => {
    const newValue = {
      id,
      DummyFrom: getTranslateFromList(target.value),
      From: target.value,
      DummyTo,
      To,
      ToDataType,
    };

    editRow(id, newValue);
  };

  return (
    <div style={{ width: 'auto' }}>
      <Select
        size="small"
        fullWidth
        value={From}
        onChange={onChangeHandler}
        canDeselect={false}
        ui-ta={getUITA('Update Actions Mapping Table', 'From Values')}
        {...fieldStyles}
      >
        {dataSourceFields.map(({ Name, Label }) => {
          return (
            <MenuItem key={`${row.id} + ${Name}`} value={Name}>
              {`${Label} (${Name})`}
            </MenuItem>
          );
        })}
      </Select>
    </div>
  );
};
